// initial state of the schemes app module
const store = new Vuex.Store(
  {
    state: {
      flow: -1, // flow value is based on encryption based auth and user auth.
      // The value 1 is for encryption auth and 2 is for user auth;
      // Bearer token must not be present when the flow value is 1.
      // In other words, 1 is for new merchant integration, and 2 is for old OM integration
      config: {},
      error: {
        errorMessage: "",
        supportMessage: ""
      },
      txnErrorObject: {},
      notification: {
        show: false,
        size: "",
        message: "",
        type: "" // 'info' || 'error' || 'success'
      },
      maxSavedUpi: 10,
      bill: {},
      phone: "",
      cachedPhoneNumber: "",
      cachedOTP: "",
      signature: "",
      credentials: {
        accessToken: "",
        userId: "",
        displayName: ""
      },
      cycleInfo: {
        creditCycleLength: 0,
        creditCycleAmount: 0,
        creditCycleIndex: 0,
        expiredTime: 0,
        subscribe: 0,
        ppFlow: ""
      },
      savedCardsList: [],
      upiList: [],
      upiTxnId: "",
      emiDetails: {
        eligibility: {
          eligible: null
        },
        emi_options: []
      },
      emiDebitResponse: {},
      debitBillDetails: {},
      webDebitResponse: {},
      walletAutoDebit: 0,
      irctc: 0,
      tracking_id: "",
      walletBalance: 0,

      // transaction otp flow
      transaction: {
        flow_id: undefined,
        otp: {
          uniqueId: undefined // will last till the end of transaction. As of now it is used to create zendesk ticket.
        }
      },
      // transaction otp flow ends

      // insurance data
      insurancePlan: "1",
      insurancePolicy: {},
      // insurance data ends

      //cc-onboard data starts
      isCCLandingVisited: false,
      initUserDetails: {},
      ccForm: {},
      rescheduleReason: null,
      ccTermsStatus: {
        tncChecked: false,
        declarationChecked: true
      },
      ccIsValidOTP: false,
      creditCardData: {},
      isSoftBlockPopupDisplayed: false,
      recentTransactions: [],
      transactions: [],
      rewardsSummary: {},
      statementTxns: {},
      billHistory: {},
      companyListResponse: [],
      isCompanyPopup: true,
      filterCsqIdList: [],
      selectedTxnId: null,
      csqData: {},
      csqDataFlag: false,
      showSheet: false,
      sheetDataObj: {
        heading: "",
        infoContent: "",
        buttonText: "",
        sheetHandler: "",
        imgSrc: "",
        isHtml: false,
        htmlContent: "",
        idProp: "",
        doubleCTA: false,
        leftCtaText: "",
        leftCtaHandler: () => {},
        rightCtaText: "",
        rightCtaHandler: () => {}
      },
      expIntDataObj: {
        tncChecked: true,
        panNumber: "",
        phoneNumber: ""
      },
      widgetsList: {},
      welcomeOfferInfoObj: {},
      welcomeOffersArr: [],
      pitchWelcomeOffersArr: [],
      ccOffersList: [],
      apptHolidaysList: null,
      sbicOnboardState: undefined,
      isCCToastDisplayed: false,
      //cc-onboard data ends

      //rsa data starts
      rsaUserDetails: {
        personalDtls: {},
        vehicleDtls: {
          vehicle_type: "CAR",
          owner_type: "self",
          vehicle_num: "",
          make: "",
          model: "",
          variant: "",
          reg_year: "",
          exp_date: ""
        }
      },
      rsaErrorDetails: {
        "1": {
          name: {
            isError: true,
            message: ""
          },
          email: {
            isError: true,
            message: ""
          },
          mobile: {
            isError: true,
            message: ""
          },
          pin_code: {
            isError: true,
            message: ""
          }
        },
        "2": {
          vehicle_type: {
            isError: true,
            message: ""
          },
          owner_type: {
            isError: true,
            message: ""
          },
          vehicle_num: {
            isError: true,
            message: ""
          },
          make: {
            isError: true,
            message: ""
          },
          model: {
            isError: true,
            message: ""
          },
          variant: {
            isError: true,
            message: ""
          },
          reg_year: {
            isError: true,
            message: ""
          },
          exp_date: {
            isError: true,
            message: ""
          }
        }
      },
      showRSALoader: false,
      rsaMobileNumber: "",
      isTokenRefreshed: false,
      //rsa data ends

      //pp-all data starts
      user_details: {
        panNumber: "",
        email: "",
        altPhone: ""
      },
      whatsappConsentStatus: false,

      ccPitchPageVersion:
        window.owConfig.ccABTest && window.owConfig.ccABTest.defaultVersion,

      //motor-insurance rsa query parameters
      parameterData: {},

      //split treatments
      splitTreatments: {}
    },
    getters: {
      getWalletBalance: state => state.walletBalance,
      getEmiDebitResponse: state => state.emiDebitResponse,
      getWebDebitResponse: state => state.webDebitResponse,
      getTransactionOtpUniqueId: state => {
        return state.transaction.otp.uniqueId;
      },
      getUPIList: state => {
        return state.upiList;
      },
      getCardsList: state => {
        return state.savedCardsList;
      },
      getEmiDetails: state => state.emiDetails,
      getActionDetails: state => action => {
        return state.debitBillDetails.action_details[action];
      },
      getTermsAndConditions: state => {
        if (state.debitBillDetails.action_details) {
          return {
            link: state.debitBillDetails.action_details["tnc_link"],
            text: state.debitBillDetails.action_details["tnc_text"]
          };
        }
      },
      getCycleInfo: state => () => {
        let cycle = {
          creditCycleLength: state.cycleInfo.creditCycleLength,
          creditCycleAmount: state.cycleInfo.creditCycleAmount,
          creditCycleIndex: state.cycleInfo.creditCycleIndex,
          creditCycleFlow: state.cycleInfo.ppFlow,
          expiredTime: state.cycleInfo.expiredTime,
          subscribe: state.cycleInfo.subscribe
        };
        return cycle;
      },
      getAction: state => () => {
        return state.debitBillDetails && state.debitBillDetails.action;
      },
      getMixAuthHeaders: state => {
        let headers = {
          Authorization: "Bearer " + state.credentials.accessToken,
          signature: state.signature,
          "Content-Type": "application/json",
          Accept: "application/json;charset=UTF-8",
          tenant: "WebView"
        };
        return headers;
      },
      getHeaders: () => () => {
        let headers = {
          "Content-Type": "application/json",
          Accept: "application/json;charset=UTF-8",
          tenant: "WebView"
        };

        return headers;
      },
      getAuthHeaders: state => isJson => {
        let headers = {
          "Content-Type": isJson
            ? "application/json"
            : "application/x-www-form-urlencoded",
          Accept: "application/json;charset=UTF-8",
          tenant: "WebView"
        };
        if (state.flow === 1) {
          headers["signature"] = state.signature;
        } else {
          headers["Authorization"] = "Bearer " + state.credentials.accessToken;
        }
        return headers;
      },
      getEmiHeaders: state => isJson => {
        let headers = {
          "Content-Type": isJson
            ? "application/json"
            : "application/x-www-form-urlencoded",
          Accept: "application/json;charset=UTF-8",
          tenant: "WebView"
        };
        if (state.flow === 1) {
          headers["signature"] = state.signature;
        }
        headers["Authorization"] = "Bearer " + state.bill.userAccessToken;
        return headers;
      },
      getBill: state => {
        return state.bill;
      },

      getPostpaidLinkPayload: state => {
        let data = {};
        data.mobile = state.phone;
        data.signature = state.signature;
        data.accessToken = state.bill.accessToken;
        data.uniqueId = state.bill.uniqueId;

        data.bill = JSON.stringify(state.bill);
        return data;
      },

      getCredentialsFromStateOrData: state => data => {
        let userId = state.credentials && state.credentials.userId;
        let accessToken = state.credentials && state.credentials.accessToken;
        return {
          userId: (data && data.userId) || userId || "",
          accessToken: (data && data.accessToken) || accessToken
        };
      },
      //cc-onboard getters start
      getInitUserDetails: state => {
        return state.initUserDetails;
      },
      getCCFormData: state => {
        return state.ccForm;
      },
      getCCTermsStatus: state => {
        return state.ccTermsStatus;
      },
      getAuthFlagCheckDoneFromStore: state => {
        return state.authFlagCheckDone;
      },
      getCreditCardDetailsFromStore: state => {
        return state.creditCardData;
      },
      getSoftBlockPopupDisplayStatus: state => {
        return state.isSoftBlockPopupDisplayed;
      },
      getWidgetsListFromStore: state => pageType => {
        return state.widgetsList[pageType];
      },
      getwelcomeOfferInfoObjFromStore: state => {
        return state.welcomeOfferInfoObj;
      },
      getWelcomeOffersFromStore: state => {
        return state.welcomeOffersArr;
      },
      getPitchWelcomeOffersFromStore: state => {
        return state.pitchWelcomeOffersArr;
      },
      getCCOffersFromStore: state => {
        return state.ccOffersList;
      },
      getApptHolidays: state => {
        return state.apptHolidaysList;
      },
      //cc-onboard getters end
      //RSA getters start
      getRSAPersonalDetails: state => {
        return state.rsaUserDetails.personalDtls;
      },
      getRSAVehicleDetails: state => {
        return state.rsaUserDetails.vehicleDtls;
      },
      getRSAErrorDetails: state => page => {
        return state.rsaErrorDetails[page];
      },
      getRecentTransactionsFromStore: state => {
        return state.recentTransactions;
      },
      getTransactionsFromStore: state => {
        return state.transactions;
      },
      getRewardsSummaryFromStore: state => {
        return state.rewardsSummary;
      },
      getStatementTxns: state => {
        return state.statementTxns;
      },
      getBillHistory: state => {
        return state.billHistory;
      },
      getCompanyListResponse: state => {
        return state.companyListResponse;
      },
      getCompanyPopupStatus: state => {
        return state.isCompanyPopup;
      },
      getFilterCsqIdList: state => {
        return state.filterCsqIdList;
      },
      getSelectedTxnId: state => {
        return state.selectedTxnId;
      },
      getCsqListByPageId: state => pageId => {
        return state.csqData[pageId];
      },
      getCsqListHeadingByPageId: state => pageId => {
        const splitIdx = pageId.lastIndexOf("_");
        let heading;
        if (splitIdx !== -1) {
          const firstPart = pageId.substring(0, splitIdx),
            secondPart = pageId.substring(splitIdx + 1);
          heading =
            state.csqData[firstPart].find(data => data.pageId === pageId)[
              "name"
            ] || "Card Support";
        } else {
          heading = "Card Support";
        }
        return heading;
      },
      getCsqFlagFromStore: state => {
        return state.csqDataFlag;
      },
      parameterData: state => {
        return state.parameterData;
      },
      getSbicOnboardState: state => state.sbicOnboardState,
      getCCToastDisplayStatus: state => state.isCCToastDisplayed,

      //common getter
      getSheetStateFromStore: state => {
        return state.showSheet;
      },
      getSheetDataObjFromStore: state => {
        return state.sheetDataObj;
      },

      //express interest getter
      getExpIntData: state => {
        return state.expIntDataObj;
      },

      getIsTokenRefreshed: state => {
        return state.isTokenRefreshed;
      },

      //pp-all data
      getPPUserDetails: state => {
        return state.user_details;
      },

      getPhoneNumber: state => state.phone,

      getCachedPhoneNumber: state => state.cachedPhoneNumber,

      getCachedOTP: state => state.cachedOTP,

      getTrackingId: state => {
        return state.tracking_id;
      },

      getCCPitchPageVersion: state => {
        return state.ccPitchPageVersion;
      },

      getIsCCLandingVisited: state => {
        return state.isCCLandingVisited;
      },

      isPPTxnAllowed: state => state.debitBillDetails.pptxnAllowed,

      getPPStatus: state => state.debitBillDetails.pp_plus_status,

      getWaConsentStatus: state => state.whatsappConsentStatus,

      getRedirectionUrl: state => {
        return decodeURIComponent(state.bill.returnUrl);
      },

      getHashedUrl: state => state.hashedUrl,

      getSplitTreatments: state => state.splitTreatments,

      getDisplayErrorForTxn: state => {
        return (
          state.txnErrorObject.display_message || state.txnErrorObject.message
        );
      },
      getTxnErrorObject: state => {
        return state.txnErrorObject;
      }
    },
    mutations: {
      SET_TXN_ERROR(state, value) {
        state.txnErrorObject = value;
      },
      SET_TRANSACTION_OTP_UNIQUE_ID(state, value) {
        state.transaction.otp.uniqueId = value;
      },
      // we can use the ES2015 computed property name feature
      // to use a constant as the function name
      SET_FLOW(state, value) {
        state.flow = value;
      },

      RESET_FLOW(state) {
        state.flow = -1;
      },

      SET_TRACKING_ID(state, value) {
        state.tracking_id = value;
      },

      SET_CONFIG(state, value) {
        Object.assign(state.config, value);
      },

      RESET_CONFIG(state) {
        Object.assign(state.config, {});
      },
      HIDE_NOTIFICATION(state) {
        Object.assign(state.notification, {
          show: false,
          size: "",
          message: "",
          type: ""
        });
      },

      SHOW_NOTIFICATION_ERROR(state, { message, size, header }) {
        window.scrollTo(0, 0);
        Object.assign(state.notification, {
          message,
          size: size,
          show: true,
          type: "error",
          header
        });
      },

      SET_CYCLE_INFO(state, payload) {
        state.cycleInfo.creditCycleLength = payload.cycle;
        state.cycleInfo.creditCycleAmount = payload.amount;
        state.cycleInfo.creditCycleIndex = payload.index;
        state.cycleInfo.expiredTime = payload.expiredTime;
        state.cycleInfo.subscribe =
          payload.attributes && payload.attributes.subscribe;
        if (payload.attributes && payload.attributes["pp-all"]) {
          if (payload.attributes["pp-all"] === "minKyc") {
            state.cycleInfo.ppFlow = "pp-all";
          } else if (payload.attributes["pp-all"] === "experian") {
            state.cycleInfo.ppFlow = "pp-all-experian";
          } else if (payload.attributes["pp-all"] === "sms") {
            state.cycleInfo.ppFlow = "pp-all-sms-read";
          }
        }
      },

      SHOW_NOTIFICATION_MESSAGE(state, { message, size }) {
        window.scrollTo(0, 0);
        Object.assign(state.notification, {
          message,
          size: size,
          show: true,
          type: "info"
        });
      },

      SHOW_NOTIFICATION_SUCCESS(state, { message, size }) {
        window.scrollTo(0, 0);
        Object.assign(state.notification, {
          message,
          size: size,
          show: true,
          type: "success"
        });
      },

      SET_ERROR(state, value) {
        Object.assign(state.error, {
          errorMessage: value.errorMessage || "Something went wrong",
          supportMessage: value.supportMessage || ""
        });
      },

      RESET_ERROR(state) {
        Object.assign(state.error, {
          errorMessage: "Something went wrong",
          supportMessage: ""
        });
      },

      SET_BILL(state, value) {
        if (Object.keys(state.bill).length === 0) {
          Object.assign(state.bill, value);
        }
      },

      RESET_BILL(state) {
        Object.assign(state.bill, {});
      },

      SET_PHONE(state, value) {
        state.phone = value;
      },

      RESET_PHONE(state) {
        state.phone = "";
      },

      SET_CACHED_PHONE_NUMBER(state, value) {
        state.cachedPhoneNumber = value;
      },

      SET_CACHED_OTP(state, value) {
        state.cachedOTP = value;
      },

      RESET_CACHED_OTP(state) {
        state.cachedOTP = "";
      },

      SET_SIGNATURE(state, value) {
        state.signature = value;
      },

      SIGNATURE(state) {
        state.signature = "";
      },

      SET_HASHED_URL(state, value) {
        state.hashedUrl = value;
      },

      SET_CREDENTIALS(state, value) {
        Object.assign(state.credentials, {
          accessToken: value.accessToken || "",
          userId: value.userId || "",
          displayName: value.displayName || ""
        });
      },

      RESET_CREDENTIALS(state) {
        Object.assign(state.credentials, {
          accessToken: "",
          userId: "",
          displayName: ""
        });
      },

      SET_EMI_DETAILS(state, value) {
        Object.assign(state.emiDetails, value);
      },

      SET_DEBIT_DETAILS(state, value) {
        Object.assign(state.debitBillDetails, value);
      },
      SET_EMI_DEBIT_RESPONSE(state, value) {
        Object.assign(state.emiDebitResponse, value);
      },
      SET_WEB_DEBIT_RESPONSE(state, value) {
        Object.assign(state.webDebitResponse, value);
      },
      SET_SAVED_CARDS(state, value) {
        if (value) {
          Object.assign(state.savedCardsList, value);
        }
      },
      DELETE_SAVED_CARDS(state, value) {
        if (Array.isArray(state.savedCardsList)) {
          state.savedCardsList = state.savedCardsList.filter(card => {
            return card.card_token === value;
          });
        }
      },
      SET_SAVED_UPI(state, value) {
        if (value) {
          Object.assign(state.upiList, value);
        }
      },
      SET_WALLET_AUTODEBIT(state) {
        state.walletAutoDebit = 1;
      },
      RESET_WALLET_AUTODEBIT(state) {
        state.walletAutoDebit = 0;
      },
      SET_IRCTC(state) {
        state.irctc = 1;
      },
      SET_WALLET_BALANCE(state, value) {
        state.walletBalance = value;
      },

      // insurance setters
      SET_INSURANCE_PLAN(state, value) {
        state.insurancePlan = value;
      },

      SET_INSURANCE_POLICY(state, value) {
        state.insurancePolicy = value;
      },
      // insurance setters ends

      //cc onboard mutation starts
      SET_CC_LANDING_VISITED_FLAG(state) {
        state.isCCLandingVisited = true;
      },
      SET_INIT_USER_DETAILS(state, payload) {
        Object.assign(state.initUserDetails, payload);
      },
      SET_RESCHEDULE_REASON(state, payload) {
        state.rescheduleReason = payload;
      },
      SAVE_CC_FORM(state, payload) {
        state.ccForm = payload;
      },
      SET_CC_TERMS_STATUS(state, payload) {
        state.ccTermsStatus = payload;
      },
      SET_IS_VALID_OTP(state, value) {
        state.ccIsValidOTP = value;
      },
      SET_AUTH_FLAG_CHECK_DONE(state, value) {
        state.authFlagCheckDone = value;
      },
      SET_CREDIT_CARD_DETAILS(state, payload) {
        state.creditCardData = payload;
      },
      SET_SOFT_BLOCK_DISPLAY_STATUS(state, bool) {
        state.isSoftBlockPopupDisplayed = bool;
      },
      SET_WIDGETS_LIST(state, payload) {
        const { pageType, widgetsList } = payload;
        const widgetsListObj = Object.assign({}, state.widgetsList);
        widgetsListObj[pageType] = widgetsList;
        Object.assign(state.widgetsList, widgetsListObj);
      },
      SET_WELCOME_OFFER_DATA(state, payload) {
        state.welcomeOfferInfoObj = payload;
      },
      SET_WELCOME_OFFERS(state, payload) {
        state.welcomeOffersArr = payload;
      },
      SET_PITCH_WELCOME_OFFERS(state, payload) {
        state.pitchWelcomeOffersArr = payload;
      },
      SET_CC_OFFERS_LIST(state, payload) {
        state.ccOffersList = payload;
      },
      SET_APPT_HOLIDAYS(state, payload) {
        state.apptHolidaysList = payload;
      },
      SET_CC_TOAST_DISPLAY_STATUS(state, payload) {
        state.isCCToastDisplayed = payload;
      },
      //cc onboard mutation ends

      //RSA mutation starts
      SET_RSA_PERSONAL_DETAILS(state, value) {
        Object.assign(state.rsaUserDetails.personalDtls, value);
      },
      CLEAR_RSA_VEHICLE_DETAILS(state, value) {
        state.rsaUserDetails.vehicleDtls = value;
      },
      SET_RSA_VEHICLE_DETAILS(state, value) {
        Object.assign(state.rsaUserDetails.vehicleDtls, value);
      },
      SET_RSA_ERROR_DETAILS(state, value) {
        const { page, errorData } = value;
        const errorObj = Object.assign({}, state.rsaErrorDetails);
        errorObj[page] = errorData;
        Object.assign(state.rsaErrorDetails, errorObj);
      },
      SET_SHOW_RSA_LOADER(state, value) {
        state.showRSALoader = value;
      },
      SET_RSA_MOBILE_NUMBER(state, value) {
        state.rsaMobileNumber = value;
      },
      UPDATE_PARAMETER_DATA(state, obj) {
        Object.assign(state.parameterData, obj);
      },
      RESET_RSA_DATA(state) {
        state.rsaUserDetails = {
          personalDtls: {},
          vehicleDtls: {
            vehicle_type: "CAR",
            owner_type: "self",
            vehicle_num: "",
            make: "",
            model: "",
            variant: "",
            reg_year: "",
            exp_date: ""
          }
        };
        state.rsaErrorDetails = {
          "1": {
            name: {
              isError: true,
              message: ""
            },
            email: {
              isError: true,
              message: ""
            },
            mobile: {
              isError: true,
              message: ""
            },
            pin_code: {
              isError: true,
              message: ""
            }
          },
          "2": {
            vehicle_type: {
              isError: true,
              message: ""
            },
            owner_type: {
              isError: true,
              message: ""
            },
            vehicle_num: {
              isError: true,
              message: ""
            },
            make: {
              isError: true,
              message: ""
            },
            model: {
              isError: true,
              message: ""
            },
            variant: {
              isError: true,
              message: ""
            },
            reg_year: {
              isError: true,
              message: ""
            },
            exp_date: {
              isError: true,
              message: ""
            }
          }
        };
      },
      SET_RECENT_TRANSACTIONS(state, payload) {
        state.recentTransactions = payload;
      },
      SET_ALL_TRANSACTIONS(state, payload) {
        state.transactions = payload;
      },
      SET_REWARDS_SUMMARY(state, payload) {
        state.rewardsSummary = payload;
      },
      SAVE_STATEMENT_TXNS(state, payload) {
        state.statementTxns = payload;
      },
      SAVE_BILL_HISTORY(state, payload) {
        state.billHistory = payload;
      },
      SET_COMPANY_LIST_RESPONSE(state, payload) {
        state.companyListResponse = payload;
      },
      SET_COMPANY_POPUP_STATUS(state, payload) {
        state.isCompanyPopup = payload;
      },
      SET_FILTER_CSQ_ID_LIST(state, payload) {
        state.filterCsqIdList = payload;
      },
      SET_SELECTED_TXN_ID(state, payload) {
        state.selectedTxnId = payload;
      },
      SET_CSQ_DATA(state, payload) {
        state.csqData = payload;
      },
      SET_CSQ_FLAG(state, payload) {
        state.csqDataFlag = payload;
      },
      SET_SBIC_ONBOARD_STATE(state, type) {
        state.sbicOnboardState = type;
      },

      //common setter
      SET_SHEET_STATE(state, bool) {
        state.showSheet = bool;
      },
      SET_SHEET_DATA(state, data) {
        state.sheetDataObj = data;
      },
      RESET_SHEET_DATA(state) {
        state.sheetDataObj = {
          heading: "",
          infoContent: "",
          buttonText: "",
          sheetHandler: "",
          imgSrc: "",
          isHtml: false,
          htmlContent: "",
          idProp: "",
          doubleCTA: false,
          leftCtaText: "",
          leftCtaHandler: () => {},
          rightCtaText: "",
          rightCtaHandler: () => {}
        };
      },

      //express interest
      SET_EXP_INT_DATA(state, payload) {
        state.expIntDataObj = payload;
      },

      SET_IS_TOKEN_REFRESHED(state, payload) {
        state.isTokenRefreshed = payload;
      },

      //PP-all
      SET_PP_ALL_USER_DETAILS(state, value) {
        Object.assign(state.user_details, value);
      },
      SET_WHATSAPP_CONSENT_STATUS(state, value) {
        state.whatsappConsentStatus = value;
      },

      //CC - Pitchpage A/B Test
      SET_CC_PITCHPAGE_VARIANT(state, value) {
        state.ccPitchPageVersion = value;
      },

      //Save SPLIT treatments
      SAVE_SPLIT_TREATMENTS(state, value) {
        state.splitTreatments = value;
      }
    },
    actions: {
      /**
       * Creates Zendesk ticket
       */
      createZendeskTicket({ getters }, payload) {
        return axios
          .post("api/v4/account/transactions/support", payload, {
            headers: getters.getAuthHeaders(true)
          })
          .then(res => res)
          .catch(error => {
            // // Raven.captureException(error);
            throw error;
          });
      },
      /**
       * Gets wallet's balance
       */
      getWalletBalance({ commit, getters }) {
        return axios
          .get("api-merchant/getWalletBalance", {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            commit("SET_WALLET_BALANCE", data.walletBalance);
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },
      /**
       * Generates bill and handling response for the given amount and returnUrlGets. Used for Internal Merchant - Ola Foundation.
       */
      fetchDebitBillInternal({ commit, getters }, payload) {
        return axios
          .post(
            "api-merchant/handleBill/v5/handleWebDebitBillInternal",
            payload,
            {
              headers: getters.getAuthHeaders(true)
            }
          )
          .then(({ data }) => {
            commit("SET_DEBIT_DETAILS", data.split_response);
            commit("SET_BILL", data.bill);
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },
      fetchDebitBill({ commit, state, getters }) {
        let bill = state.bill;
        bill.phoneNumber = getters.getPhoneNumber;
        return axios
          .post("api-merchant/handleBill/v5/handleWebDebitBill", bill, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            commit("SET_DEBIT_DETAILS", data);
          })
          .catch(error => {
            commit("SET_TXN_ERROR", error.response && error.response.data);
            // Raven.captureException(error);
            throw error;
          });
      },
      fetchEmiDetails({ commit, state, getters }) {
        let payload = {
          user_id: state.credentials.userId,
          merchant_access_token: state.bill.accessToken,
          transaction_amount: state.bill.amount,
          udf: state.bill.udf
        };

        return axios
          .post("api-emi/emi/eligibility", payload, {
            headers: getters.getEmiHeaders(true)
          })
          .then(({ data }) => {
            commit("SET_EMI_DETAILS", data);
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      emiWebDebit({ commit, getters, state }, payload) {
        const bill = Object.assign({}, state.bill);
        bill.subType = "emi";
        payload.amount = bill.amount;
        payload.web_debit_request.bill = bill;
        let headers = getters.getEmiHeaders(true);
        return axios({
          method: "post",
          url: "api-emi/txn/emiwebdebit",
          data: payload,
          headers: headers
        })
          .then(({ data }) => {
            data.returnUrl = state.bill.returnUrl;
            commit("SET_EMI_DEBIT_RESPONSE", data);
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      handleLoadMoneyBill({ commit, state, getters }) {
        let bill = state.bill;
        return axios
          .get(`api-merchant/handleLoadMoneyBill?amount=${bill.amount}`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            commit("SET_DEBIT_DETAILS", data);
          })
          .catch(error => {
            commit("SET_TXN_ERROR", error.response && error.response.data);
            // Raven.captureException(error);
            throw error;
          });
      },

      fetchSaveCards({ commit, state, getters }, type) {
        const data = {
          userId: state.credentials.userId,
          userAccessToken: state.credentials.accessToken,
          type: type
        };
        return axios({
          method: "post",
          url: "api-public/v2/payuint/savedCards",
          data: data,
          headers: getters.getMixAuthHeaders
        })
          .then(({ data }) => {
            commit("SET_SAVED_CARDS", data.user_cards);

            // save user id for further transactions in case of auto debit
            let obj = getters.getCredentialsFromStateOrData(data);
            commit("SET_CREDENTIALS", obj);

            return data.user_cards;
          })
          .catch(error => {
            commit("SET_TXN_ERROR", error.response && error.response.data);
            // Raven.captureException(error);
            throw error;
          });
      },
      fetchSavedUPI({ commit, state, getters }) {
        return axios
          .get(`api-public/v1/upi/list?max=${state.maxSavedUpi}`, {
            headers: getters.getMixAuthHeaders
          })
          .then(({ data }) => {
            commit("SET_SAVED_UPI", data.upiTransactionList);
            return data.upiTransactionList;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },
      userDebit({ commit, getters, state }, data) {
        data.bill = state.bill;
        let headers = getters.getAuthHeaders(true);
        return axios({
          method: "post",
          url: "api-merchant/userdebit/v5/webdebit",
          data: data,
          headers: headers
        })
          .then(({ data }) => {
            data.returnUrl = state.bill.returnUrl;
            commit("SET_WEB_DEBIT_RESPONSE", data);
            return data;
          })
          .catch(error => {
            commit("SET_TXN_ERROR", error.response && error.response.data);
            // Raven.captureException(error);
            throw error;
          });
      },
      getInitiatedTxnDetailsForVerification({ commit, getters }, payload) {
        let url = "api/v1/postpaid/initiatedTxnDetails";
        let app_version =
          (window.owConfig.metaData &&
            window.owConfig.metaData["app_version"]) ||
          "";
        let manufacturer =
          (window.owConfig.metaData &&
            window.owConfig.metaData["manufacturer"]) ||
          "";
        let model =
          (window.owConfig.metaData && window.owConfig.metaData["model"]) || "";
        let device_type = manufacturer + model;
        let headers = Object.assign({}, getters.getAuthHeaders(true), {
          "App-Version": app_version,
          "Device-Type": device_type
        });

        return axios
          .post(url, payload, {
            headers: headers
          })
          .then(({ data }) => {
            return data;
          })
          .catch(err => {
            Raven.captureException(err);
            throw err;
          });
      },
      fetchOptionsForConcerns({ getters }) {
        let url = "api/v1/postpaid/txnConcernReasons";
        let app_version =
          (window.owConfig.metaData &&
            window.owConfig.metaData["app_version"]) ||
          "";
        let manufacturer =
          (window.owConfig.metaData &&
            window.owConfig.metaData["manufacturer"]) ||
          "";
        let model =
          (window.owConfig.metaData && window.owConfig.metaData["model"]) || "";
        let device_type = manufacturer + model;
        let headers = Object.assign({}, getters.getAuthHeaders(true), {
          "App-Version": app_version,
          "Device-Type": device_type
        });

        return axios
          .get(url, {
            headers: headers
          })
          .then(({ data }) => {
            return data;
          })
          .catch(err => {
            Raven.captureException(err);
            throw err;
          });
      },
      submitConcernsForThisTransaction({ getters }, payload) {
        let url = "api/v1/postpaid/submitTxnConcern";
        let app_version =
          (window.owConfig.metaData &&
            window.owConfig.metaData["app_version"]) ||
          "";
        let manufacturer =
          (window.owConfig.metaData &&
            window.owConfig.metaData["manufacturer"]) ||
          "";
        let model =
          (window.owConfig.metaData && window.owConfig.metaData["model"]) || "";
        let device_type = manufacturer + model;
        let headers = Object.assign({}, getters.getAuthHeaders(true), {
          "App-Version": app_version,
          "Device-Type": device_type
        });

        return axios
          .post(url, payload, {
            headers: headers
          })
          .then(({ data }) => {
            return data;
          })
          .catch(err => {
            Raven.captureException(err);
            throw err;
          });
      },
      generateOtp({ commit, state }, { encData, phone }) {
        let payload = {};
        let url = "api-public/v3/generateOTP";
        if (encData) {
          url = "api-public/v3/irctc/generateOTP";
          payload.encData = encData;
        } else {
          payload.bill = state.bill;
        }
        payload.phoneNumber = phone;

        return axios
          .post(url, payload)
          .then(({ data }) => {
            if (encData && data.bill) {
              commit("SET_BILL", data.bill);
            }
            return data;
          })
          .catch(error => {
            commit("SET_TXN_ERROR", error.response && error.response.data);
            // Raven.captureException(error);
            throw error;
          });
      },
      verifyOTP({ commit, state }, otp) {
        let payload = {};
        payload.bill = state.bill;
        payload.phoneNumber = state.phone;
        payload.otp = otp;
        return axios
          .post(`api-public/v3/validateOTP`, payload)
          .then(({ data }) => {
            state.bill.userAccessToken = data.accessToken;
            state.bill.phoneNumber = data.mobile || state.phone || "";
            commit("SET_PHONE", data.mobile || state.phone || "");
            let obj = {
              accessToken: data.accessToken ? data.accessToken : "",
              userId: data.userId ? data.userId : "",
              displayName: data.merchantDisplayName
            };
            return commit("SET_CREDENTIALS", obj);
          })
          .catch(error => {
            commit("SET_TXN_ERROR", error.response && error.response.data);
            // Raven.captureException(error);
            throw error;
          });
      },
      generateWebBill({ commit, state, getters }, amount) {
        return axios
          .post(
            `api-public/v1/payuint/generateWebBill?amount=${amount}`,
            state.bill,
            {
              headers: getters.getAuthHeaders(true)
            }
          )
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },
      generateBillForType({ commit, state, getters }, payload) {
        let bill = state.bill;
        let data = {
          bill: bill,
          type: payload.type,
          amount: payload.amount
        };
        return axios
          .post(`api-public/v1/payuint/generateWebBillForType`, data, {
            headers: getters.getMixAuthHeaders
          })
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },
      generateLoadMoneyWebBill({ commit, state, getters }, payload) {
        return axios
          .post(
            `api-public/v1/payuint/generateLoadMoneyWebBill?amount=${payload.amount}`,
            state.bill,
            {
              headers: getters.getMixAuthHeaders
            }
          )
          .then(({ data }) => {
            return { getWebBillResponse: data };
          })
          .catch(error => {
            commit("SET_TXN_ERROR", error.response && error.response.data);
            // Raven.captureException(error);
            throw error;
          });
      },
      payUPI({ commit, state, getters }, payload) {
        let headers = getters.getMixAuthHeaders;
        headers.user_agent = "webview";
        return axios
          .post(`api-public/v1/upi/pay`, payload, {
            headers: headers
          })
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            commit("SET_TXN_ERROR", error.response && error.response.data);
            // Raven.captureException(error);
            throw error;
          });
      },
      enquireUPIStatus({ commit, state, getters }, payload) {
        return axios
          .get(`api-public/v1/upi/status?txn_id=${payload.order_id}`, {
            headers: getters.getMixAuthHeaders
          })
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      // POSTPAID actions
      getUserMerchantLink({ commit, getters, state }) {
        let headers = getters.getHeaders();
        headers.signature = state.signature;
        return axios
          .post(
            "api-merchant/v1/postpaid/getUserMerchantLink",
            getters.getPostpaidLinkPayload,
            {
              headers: headers
            }
          )
          .then(({ data }) => {
            let obj = getters.getCredentialsFromStateOrData(data);
            commit("SET_CREDENTIALS", obj);
            return data;
          })
          .catch(error => {
            commit("SET_TXN_ERROR", error.response && error.response.data);
            // Raven.captureException(error);
            throw error;
          });
      },

      addPostpaidLink({ commit, getters, state }) {
        return axios
          .post(
            "api-merchant/v1/postpaid/addPostpaidLink",
            getters.getPostpaidLinkPayload
          )
          .then(({ data }) => {
            let obj = getters.getCredentialsFromStateOrData(data);
            commit("SET_CREDENTIALS", obj);

            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      linkPostpaid({ commit, getters, state }, data) {
        data = Object.assign(data, getters.getPostpaidLinkPayload);
        data.linkNotifUrl = state.config.linkNotifUrl;
        return axios
          .post("api-merchant/v1/postpaid/linkPostpaid", data)
          .then(({ data }) => {
            state.bill.userAccessToken = data.accessToken;
            state.bill.phoneNumber = data.mobile || state.phone || "";
            commit("SET_PHONE", data.mobile || state.phone || "");

            let obj = getters.getCredentialsFromStateOrData(data);
            commit("SET_CREDENTIALS", obj);

            return data;
          })
          .catch(error => {
            commit("SET_TXN_ERROR", error.response && error.response.data);
            // Raven.captureException(error);
            throw error;
          });
      },

      debitWithOtp({ commit, getters, state }, otp) {
        let payload = {};
        Object.assign(payload, state.bill);
        payload.otp = otp;
        payload.phoneNumber = getters.getPhoneNumber;
        payload.signature = state.signature;
        return axios
          .post("api-merchant/v1/postpaid/debitWithOtp", payload)
          .then(({ data }) => {
            let obj = getters.getCredentialsFromStateOrData(data);
            commit("SET_CREDENTIALS", obj);

            state.bill.userAccessToken = obj.accessToken;
            return data;
          })
          .catch(error => {
            commit("SET_TXN_ERROR", error.response && error.response.data);
            // Raven.captureException(error);
            throw error;
          });
      },

      postpaidCancel({ commit, state }) {
        let bill = state.bill;
        return axios
          .post("api-merchant/cancel/v1/postpaid/cancel", bill)
          .then(({ data }) => {
            data.returnUrl = state.bill.returnUrl;
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      cancel({ commit, state, getters }) {
        let bill = state.bill;
        return axios
          .post(`api-public/v1/cancel`, bill, {
            headers: getters.getHeaders()
          })
          .then(({ data }) => {
            data.returnUrl = state.bill.returnUrl;
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },
      convertToIRCTC({ commit, state, getters }, payload) {
        if (Object.keys(state.bill).length !== 0) {
          payload.bill = state.bill;
        }
        return axios
          .post(`api-public/v1/irctc/convertToIRReceipt`, payload, {
            headers: getters.getHeaders()
          })
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },
      getRideStatus({ commit, getters }) {
        return axios
          .get("api-postpaid/v1/user/ride/inprogress", {
            headers: getters.getAuthHeaders()
          })
          .then(response => {
            return response;
          })
          .catch(error => {
            if (error.response && error.response.status === 404) {
              return {
                status: error.response.status
              };
            } else {
              // Raven.captureException(error);
              throw error;
            }
          });
      },
      setPPAsDefaultIntrument({ commit, getters }, rideStatus) {
        let url = "api-postpaid/v1/user/instrument/default";
        if (rideStatus) {
          url += `?ride_status=${rideStatus}&source=pp_activation_flow`;
        }
        return axios
          .put(
            url,
            {},
            {
              headers: getters.getAuthHeaders(true)
            }
          )
          .then(response => {
            return response;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      getIRCTCFailureReceipt({ commit, state, getters }, payload) {
        if (Object.keys(state.bill).length !== 0) {
          payload.bill = state.bill;
        }
        return axios
          .post(`api-public/v1/irctc/getFailureReceipt`, payload, {
            headers: getters.getHeaders()
          })
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      getSaltedHash({ commit, getters, state }, text) {
        let payload = {
          text
        };
        return axios
          .post("saltedHash", payload)
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      // Connect APIs actions
      publishEvent({ state, getters }, event) {
        axios
          .post("api-connect/v1/connect/event", event, {
            headers: getters.getMixAuthHeaders
          })
          .then(value => {})
          .catch(({ response }) => {
            if (response.status === 401) {
              this.dispatch("publishPublicEvent", event);
            }
          });
      },

      publishPublicEvent({ state, getters }, event) {
        axios
          .post("api-connect/v1/connect/public/event", event, {
            headers: getters.getHeaders()
          })
          .then(value => {})
          .catch(reason => {});
      },

      publishPPallEvent({ state, getters }, event) {
        const headers = getters.getHeaders();
        headers["Authorization"] = "Bearer " + state.credentials.accessToken;
        axios
          .post("api-connect/v1/clevertap/event", event, {
            headers: headers
          })
          .then(value => {})
          .catch(reason => {});
      },
      // Connect APIs actions ends

      // Accept Credit APIs
      getCycleAmountInfo({ state, getters }) {
        return axios
          .get("api/v1/credit/cycleamountinfo", {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      minKycGenerateOTP({ state, getters }) {
        return axios
          .post(
            `api/v1/context/{context}/generateOTP?context=${state.cycleInfo.ppFlow}`,
            {},
            {
              headers: getters.getAuthHeaders(true)
            }
          )
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      minKycVerifyOTP({ state, getters }, payload) {
        return axios
          .post("api/v1/context/user/validateOTP", payload, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      saveMinKycDetails({ state, getters }, payload) {
        let headers = Object.assign({}, getters.getAuthHeaders(true), {
          "App-Version": window.owConfig.app_version,
          user_agent: payload.user_agent,
          tenant: window.owConfig.tenant || "CabsAPP"
        });

        let payloadToApi = Object.assign({}, payload);

        if (payload.user_agent) {
          delete payloadToApi.user_agent;
        }

        return axios
          .post(
            `api-ofs-kyc/v1/data/${state.cycleInfo.ppFlow}/saveStep/personal_details`,
            payloadToApi,
            {
              headers: headers
            }
          )
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      getMinKycDetails({ state, getters }) {
        return axios
          .get(
            `api-ofs-kyc/v1/data/${state.cycleInfo.ppFlow}/getStepData?ui=true`,
            {
              headers: getters.getAuthHeaders(true)
            }
          )
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      minKycQuery({ state, getters }, payload) {
        return axios
          .post(`api-ofs-kyc/v1/data/query`, payload, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      activateOlaPostpaid({ state, getters }, payload) {
        let url = "api/v1/account/balance/subscribe?pageSource=om_webview";
        if (payload && payload.channel === "webview") {
          url = "api/v2/account/balance/subscribe?pageSource=om_webview";
        }
        return axios
          .post(url, payload, {
            headers: getters.getAuthHeaders(true)
          })
          .then(data => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      dismissOlaPostpaid({ state, getters }, payload) {
        return axios
          .post("api/v1/account/balance/subscribe", payload, {
            headers: getters.getAuthHeaders(true)
          })
          .then(data => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      getMinKycData({ state, getters }) {
        return axios
          .get("api/v1/kyc/min/kycForm", {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      getOnboardingScreenData({ state, getters }) {
        return axios
          .get("api/v1/postpaid/onboardingPage", {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      giveConsent({ commit, state, getters }, payload) {
        let waStatus = payload.enableWhatsApp;
        return axios
          .post("api-postpaid/v1/user/consents", payload, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            commit("SET_WHATSAPP_CONSENT_STATUS", waStatus);
            return data;
          })
          .catch(error => {
            // Raven.captureException(error);
            throw error;
          });
      },

      // insurance APIs

      insuranceGenerateOTP({ commit, state, getters }, phone) {
        return axios
          .post(`api/v1/generateOTP?phone=${phone}`)
          .then(({ data }) => {
            commit("SET_PHONE", phone);
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      insuranceVerifyOTP({ commit, state, getters }, otp) {
        return axios
          .post(`api/v1/validateOTP?phone=${state.phone}&otp=${otp}`)
          .then(({ data }) => {
            let obj = getters.getCredentialsFromStateOrData(data);
            commit("SET_CREDENTIALS", obj);
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      // insurance login APIs

      missedFlightGenerateOTP({ commit, state, getters }, phone) {
        return axios
          .post(
            `api-insurance-noauth/api/v1.0.0/insurance/generateOTP?phone=${phone}`,
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          )
          .then(({ data }) => {
            commit("SET_PHONE", phone);
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      missedFlightVerifyOTP({ commit, state, getters }, otp) {
        return axios
          .post(`api-insurance-noauth/api/v1.0.0/insurance/validateOTP`, {
            phone: state.phone,
            otp,
            context: "missedFlight"
          })
          .then(({ data }) => {
            let obj = getters.getCredentialsFromStateOrData(data);
            commit("SET_CREDENTIALS", obj);
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      insuranceCreatePolicy({ state, getters }) {
        let body = state.insurancePolicy;
        body.insurancePlanId = state.insurancePlan || 1; // default value 1 need to be removed later
        let headers = Object.assign({}, getters.getAuthHeaders(true), {
          context: "missedFlight"
        });

        return axios
          .post(`api-insurance/api/v1.0.0/missed-flight/create-policy`, body, {
            headers
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      // insurance APIs End
      //CC APIs Start
      submitUserData({ commit, state, getters }, userData) {
        let {
          emplDtls: {
            companyInfo: { companyName: truncateCompanyName } = {},
            designation: truncateDesignation
          } = {}
        } = userData;
        truncateCompanyName = truncateCompanyName.substr(0, 30);
        truncateDesignation = truncateDesignation.substr(0, 30);
        userData.emplDtls.companyInfo.companyName = truncateCompanyName;
        userData.emplDtls.designation = truncateDesignation;
        delete userData.personalDtls.fullName;
        delete userData.emplDtls.companyListResponse;

        commit("SAVE_CC_FORM", userData);

        return axios
          .post(`api-cc/v1/credit-card/on-board`, userData, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },
      validatePincode({ commit, state, getters }, pincode) {
        return axios
          .get(`api-cc/v1/credit-card/${pincode}/pincode`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      fetchCompanyName({ commit, state, getters }, email) {
        const domain = email.split("@")[1];
        return axios
          .get(`api-cc/v1/credit-card/${domain}/empl-domain`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      initOnboard({ commit, state, getters }) {
        return axios
          .get(`api-cc/v1/credit-card/init-onboard`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      updateAppointment({ getters }, body) {
        return axios
          .post(`api-cc/v1/credit-card/update-appointment-by-user`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(() => {
            return true;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getCreditCardDetails({ commit, state, getters }) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/account-summary`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getCompanyList({ commit, state, getters }, prefix) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/${prefix}/company-list`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getDesignationList({ commit, state, getters }, prefix) {
        return axios
          .get(
            `api-insurance/api/v1.0.0/credit-card/${prefix}/employee-designation`,
            {
              headers: getters.getAuthHeaders(true)
            }
          )
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      ccGenerateOTP({ commit, state, getters }) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/generate-otp`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      ccVerifyOTP({ commit, state, getters }, otp) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/auth-otp/${otp}`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },
      //CC APIs End
      //RSA APIs Start

      rsainit({ commit, state, getters }) {
        return axios
          .get(`api-insurance/api/v1.0.0/rsa/init`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getVehicleMakeList({ commit, state, getters, payload }) {
        return axios
          .get(`api-insurance/api/v1.0.0/rsa/make-list?type=${payload}`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      ccAccSummary({ commit, state, getters }) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/account-summary`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getRecentTransactions({ commit, state, getters }) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/recent-txns`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },
      getVehicleModelList({ commit, state, getters }, payload) {
        return axios
          .get(
            `api-insurance/api/v1.0.0/rsa/${payload.make}/models?type=${payload.type}`,
            {
              headers: getters.getAuthHeaders(true)
            }
          )
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getTransactions({ commit, state, getters }) {
        const body = {};
        return axios
          .post(`api-insurance/api/v1.0.0/credit-card/txns-by-date`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },
      getVehicleVariantList({ commit, state, getters }, data) {
        return axios
          .get(
            `api-insurance/api/v1.0.0/rsa/${data.make}/${data.model}/variants?type=${data.type}`,
            {
              headers: getters.getAuthHeaders(true)
            }
          )
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getRewardsSummary({ commit, state, getters }) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/cashback-summary`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getAppStatus({ commit, state, getters }, otp) {
        return axios
          .get(`api-cc/v1/credit-card/app-status`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      submitDetailsForRsa({ commit, state, getters }) {
        let body = Object.assign({}, state.rsaUserDetails.personalDtls);
        Object.assign(body, state.rsaUserDetails.vehicleDtls);
        body["rsa_meta"] = getters.parameterData;
        delete body["mobile"];
        return axios
          .post(`api-insurance/api/v1.0.0/rsa/create`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      storeParamsData({ commit, state, getters }, paramsList) {
        commit("UPDATE_PARAMETER_DATA", paramsList);
      },

      validateUserForRsa({ commit, state, getters }) {
        return axios
          .get(`api-insurance/api/v1.0.0/rsa/validate`)
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      sendCleverTapEvent({ commit, state, getters }, body) {
        axios.post(
          `api-insurance/api/v1.0.0/credit-card/clevertap-event`,
          body,
          {
            headers: getters.getAuthHeaders(true)
          }
        );
      },

      fetchCsq({ commit, state, getters }, otp) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/csq-list`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      submitCsqQuery({ commit, state, getters }, body) {
        return axios
          .post(
            `api-insurance/api/v1.0.0/credit-card/create-csq-ticket`,
            body,
            {
              headers: getters.getAuthHeaders(true)
            }
          )
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      submitExpressInterest({ commit, state, getters }, body) {
        return axios
          .post(`api-orchestrator/v1/express-interest/registered`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      submitPublicExpressInterest({ commit, state, getters }, body) {
        return axios
          .post(`api-orchestrator/v1/express-interest/non-registered`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getDeviceSyncInfo({ commit, state, getters }) {
        let device_id = window.owConfig.device_id || "";
        let headers = Object.assign({}, getters.getAuthHeaders(true), {
          "Device-Id": device_id,
          Context: "pp_flow"
        });
        return axios
          .get(`api-orchestrator/v1/userDeviceInfo/syncInfo`, {
            headers: headers
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getWidgetList({ commit, state, getters }, body) {
        return axios
          .post(`api-insurance/api/v1.0.0/credit-card/widgets`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },
      logInvalidToken({ commit, state, getters }, pageName) {
        const data = {
          os_name:
            (window.owConfig.metaData && window.owConfig.metaData["os_name"]) ||
            "",
          app_version:
            (window.owConfig.metaData &&
              window.owConfig.metaData["app_version"]) ||
            "",
          os_version:
            (window.owConfig.metaData &&
              window.owConfig.metaData["os_version"]) ||
            ""
        };
        return axios
          .get(
            `invalid-token-log?page_name=${pageName}&os_name=${data.os_name}&app_version=${data.app_version}&os_version=${data.os_version}`,
            {
              headers: getters.getAuthHeaders(true)
            }
          )
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      fireWidgetAction({ commit, state, getters }, body) {
        return axios.post(
          `api-insurance/api/v1.0.0/credit-card/widgets-actions`,
          body,
          {
            headers: getters.getAuthHeaders(true)
          }
        );
      },

      getWelcomeOffers({ commit, state, getters }) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/welcome-offers`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getPitchWelcomeOffers({ commit, state, getters }) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/pitch-welcome-offers`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      sendPitchPageCounterEvent({ commit, state, getters }, body) {
        return axios
          .post(`api-insurance/api/v1.0.0/credit-card/pitch-page`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getCCOffersList({ commit, state, getters }) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/all-offers`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getOfferDetails({ commit, state, getters }, body) {
        return axios
          .post(`api-insurance/api/v1.0.0/credit-card/offer-details`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      verifyPan({ commit, state, getters }, body) {
        return axios
          .post(`api-ofs-kyc/v1/nsdl/verifyPan`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getCCApplication({ commit, state, getters }) {
        return axios
          .get(`api-cc/v1/credit-card/get-cc-application-by-user`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      saveCCApplication({ commit, state, getters }, body) {
        return axios
          .put(`api-cc/v1/credit-card/save-cc-application-by-user`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      fetchTxnDetails({ commit, state, getters }, body) {
        return axios
          .post(`api-insurance/api/v1.0.0/credit-card/txn-details`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      getApptHolidays({ commit, state, getters }, body) {
        return axios
          .post(`api-insurance/api/v1.0.0/admin/get-holidays`, body, {
            headers: getters.getHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      saveSbicUserData({ commit, state, getters }, body) {
        return axios
          .post(`api-insurance/api/v1.0.0/credit-card/sbic-user-data `, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },
      billdeskInitPayment({ commit, state, getters }, body) {
        return axios
          .post(`api-insurance/api/v1.0.0/credit-card/init-payment`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      billdeskUpdatePayment({ commit, state, getters }, body) {
        return axios
          .post(`api-insurance/api/v1.0.0/credit-card/update-payment`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      fetchStatementDetails({ commit, state, getters }, body) {
        return axios
          .post(`api-insurance/api/v1.0.0/credit-card/statement-detail`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            commit("SAVE_STATEMENT_TXNS", data["all_txns"]);
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      fetchBillHistory({ commit, state, getters }) {
        return axios
          .get(`api-insurance/api/v1.0.0/credit-card/statement-cycle`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            commit("SAVE_BILL_HISTORY", data);
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },

      //split handler
      handleSplit({ commit, state, getters, dispatch }) {
        dispatch("getUserMetaData").then(res => {
          var factory = splitio({
            core: {
              authorizationKey: window.owConfig.NATIVE_SPLIT_AUTH_KEY,
              key: res.ola_user_code,
              IPAddressesEnabled: false,
              startup: {
                requestTimeoutBeforeReady: 5, // 5 seconds
                readyTimeout: 5, // 5 seconds
                retriesOnFailureBeforeReady: 2 // 2 retries
              },
              trafficType: "User"
            }
          });

          var client = factory.client();

          client.on(client.Event.SDK_READY, () => {
            const splitTreatments = {};

            const ccBilldeskPaymentFlow = client.getTreatment(
              "CC_billdesk_payment_flow"
            );

            const ccStatementView = client.getTreatment("CC_statement_view");

            splitTreatments.ccBilldeskPaymentFlow = ccBilldeskPaymentFlow;
            splitTreatments.ccStatementView = ccStatementView;

            commit("SAVE_SPLIT_TREATMENTS", splitTreatments);
          });
        });
      },

      //util handlers
      setCookie({ commit, state, getters }, payload) {
        let domain = window.owConfig.trackingCookieDomain;
        document.cookie =
          payload.name +
          "=" +
          payload.value +
          ";secure;path=/;domain=" +
          domain;
      },

      getUserMetaData({ commit, state, getters, dispatch }) {
        return axios
          .get(`api-insurance/api/v1.0.0/insurance/user-meta-data`, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            dispatch("setCookie", {
              name: "OFS_USER_CODE",
              value: data.ola_user_code
            });
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      },
      updateRating({ getters }, body) {
        return axios
          .post(`api-insurance/api/v1.0.0/platform/user-feedback`, body, {
            headers: getters.getAuthHeaders(true)
          })
          .then(({ data }) => {
            return data;
          })
          .catch(reason => {
            // Raven.captureException(reason);
            throw reason;
          });
      }
    }
  }

  // plugins: [VuexPersistence]
);
